import { useEffect } from 'react'
import { action_updateContractPartieList, action_updateContractPartieSelected, action_updateContractPresentation, action_updateElementLog, action_updateFirstLoad, action_updateFormConfigPartie, action_updateFormConfigPolynomy, action_updateFormConfigSubPartie } from '../../../reducers/actions/PAY/actions';
import { useDispatch } from 'react-redux';
import { getCargaPartida, getCargaPolinomio, getCargaSubPartida, getContractPartieElementLog, getContratoDI, getItemPartida, getItemSubPartida, getListFullPartidasSubPartidasPolinomios, getPolinomioValorBase, getPresentacionPartidaHome } from '../../../services/sPay/partie.service';
import { getCheckIfNewEdpDateNeeded } from '../../../services/sPay/edpConfig.service';
import { isNullUndefinedOrEmpty } from '../../../common/Helpers';
import moment from 'moment';


const useGetContractPartieElementLog = (logs, elementId) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getContractPartieElementLog(elementId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateElementLog(response))
                }
                else {
                    dispatch(action_updateElementLog([]))
                }
            }
            catch (error) {
                dispatch(action_updateElementLog([]))
            }
        }
        
        if (logs === null && elementId !== null) {
            doIt()
        }
    }, [logs, elementId]);
}

const useGetPresentation = (presentation, elementId, fireGetPresentation, setFireGetPresentation) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getPresentacionPartidaHome(elementId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateContractPresentation(response))
                }
                else {
                    dispatch(action_updateContractPresentation({}))
                }

                setFireGetPresentation(false)
            }
            catch (error) {
                console.log(error)
                dispatch(action_updateContractPresentation({}))
                setFireGetPresentation(false)
            }
        }
        
        if ((presentation === null || fireGetPresentation) && elementId !== null) {
            doIt()
        }
    }, [presentation, fireGetPresentation, elementId, setFireGetPresentation]);
}


const useGetContractParties = (listContractsParties, elementId, fireGetContractParties, setFireGetContractParties) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getListFullPartidasSubPartidasPolinomios(elementId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateContractPartieList(response))
                }
                else {
                    dispatch(action_updateContractPartieList([]))
                }

                dispatch(action_updateFirstLoad(true))
                setFireGetContractParties(false)
            }
            catch (error) {
                dispatch(action_updateContractPartieList([]))
                dispatch(action_updateFirstLoad(true))
                setFireGetContractParties(false)
            }
        }
        
        if ((listContractsParties === null || fireGetContractParties) && elementId !== null) {
            doIt()
        }
    }, [listContractsParties, elementId, fireGetContractParties, setFireGetContractParties]);
}

const useGetContractPartie = (partieId, contractsPartie, isPanelOpen) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getItemPartida(partieId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateContractPartieSelected(response))
                }
                else {
                    dispatch(action_updateContractPartieSelected([]))
                }
            }
            catch (error) {
                dispatch(action_updateContractPartieSelected([]))
            }
        }
        
        if (partieId !== null && contractsPartie === null && isPanelOpen) {
            doIt()
        }
    }, [partieId, contractsPartie, isPanelOpen]);
}

const useGetContractSubPartie = (subPartieId, contractsPartie, isPanelOpen) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getItemSubPartida(subPartieId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateContractPartieSelected(response))
                }
                else {
                    dispatch(action_updateContractPartieSelected([]))
                }
            }
            catch (error) {
                dispatch(action_updateContractPartieSelected([]))
            }
        }
        
        if (subPartieId !== null && contractsPartie === null && isPanelOpen) {
            doIt()
        }
    }, [subPartieId, contractsPartie, isPanelOpen]);
}

const useGetPartieFormConfig = (elemenId, partieFormConfig, fireGetPartieFormConfig, setFireGetPartieFormConfig) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getCargaPartida(elemenId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateFormConfigPartie(response))
                }
                else {
                    dispatch(action_updateFormConfigPartie({}))
                }

                setFireGetPartieFormConfig(false)
            }
            catch (error) {
                dispatch(action_updateFormConfigPartie({}))
                setFireGetPartieFormConfig(false)
            }
        }
        
        if (elemenId !== null && (partieFormConfig === null || fireGetPartieFormConfig)) {
            doIt()
        }
    }, [elemenId, partieFormConfig, fireGetPartieFormConfig, setFireGetPartieFormConfig]);
}

const useGetPolynomyFormConfig = (partieFormConfig) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getCargaPolinomio();

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateFormConfigPolynomy(response))
                }
                else {
                    dispatch(action_updateFormConfigPolynomy({}))
                }
            }
            catch (error) {
                dispatch(action_updateFormConfigPolynomy({}))
            }
        }
        
        if (partieFormConfig === null) {
            doIt()
        }
    }, [partieFormConfig]);
}

const useGetSubPartieFormConfig = (elemenId, partieFormConfig) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getCargaSubPartida(elemenId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateFormConfigSubPartie(response))
                }
                else {
                    dispatch(action_updateFormConfigSubPartie({}))
                }
            }
            catch (error) {
                dispatch(action_updateFormConfigSubPartie({}))
            }
        }
        
        if (elemenId !== null && partieFormConfig === null) {
            doIt()
        }
    }, [elemenId, partieFormConfig]);
}

const useGetPolynomyBaseValues = (nemoIndicador, startDate, listBaseValues, setListBaseValues) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                let aux_startDate = null;
                let aux_endDate = null;

                if (!isNullUndefinedOrEmpty(startDate)) {
                    const aux = startDate.split('/');

                    aux_startDate = moment(new Date(aux[0], aux[1]-1, 1)).format('MM/DD/YYYY')
                }
                else {
                    const momnth = moment(new Date.now()).month;
                    const year = moment(new Date.now()).year;

                    aux_startDate = moment('01/'+momnth+'/'+year+'/').format('MM/DD/YYYY')
                }

                const temporalEndDate = moment(aux_startDate, 'MM/DD/YYYY');
                const endDate_lastDayOfMonth = temporalEndDate.endOf('month');
              
                aux_endDate = endDate_lastDayOfMonth.format('MM/DD/YYYY');

                let serviceResponse = await getPolinomioValorBase(nemoIndicador, aux_startDate, aux_endDate);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;
                    setListBaseValues(response)
                }
                else {
                    setListBaseValues([])
                }
            }
            catch (error) {
                setListBaseValues([])
            }
        }
        
        if (listBaseValues === null && nemoIndicador !== null && startDate !== null) {
            doIt()
        }
    }, [nemoIndicador, startDate, listBaseValues, setListBaseValues]);
}

const useGetContratoDI = (elementId, listComponentAmount, setListComponentAmount) => {    
    //const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getContratoDI(elementId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;
                    setListComponentAmount(response)
                }
                else {
                    setListComponentAmount([])
                }
            }
            catch (error) {
                setListComponentAmount([])
            }
        }
        
        if (listComponentAmount === null && elementId !== null) {
            doIt()
        }
    }, [elementId, listComponentAmount, setListComponentAmount]);
}

const useOfCheckIfNewEdPDateNeeded = (elementId, edpDateNeeded, setEdpDateNeeded, setNextValidEdpDate) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getCheckIfNewEdpDateNeeded(elementId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;
                    setEdpDateNeeded(response.result)
                    let fecha_desde = !isNullUndefinedOrEmpty(response.fecha_desde) ? moment(new Date(response.fecha_desde)) : null;
                    setNextValidEdpDate && setNextValidEdpDate(new Date(fecha_desde))
                }
                else {
                    setEdpDateNeeded(null)
                }
            }
            catch (error) {
                setEdpDateNeeded(null)
            }
        }
        
        if (edpDateNeeded === undefined && elementId !== null) {
            doIt()
        }
    }, [elementId, edpDateNeeded, setEdpDateNeeded, setNextValidEdpDate]);
}

export {
    useGetContractPartieElementLog,
    useGetPresentation,
    useGetContractParties,
    useGetContractPartie,
    useGetContractSubPartie,
    useGetPartieFormConfig,
    useGetSubPartieFormConfig,
    useGetPolynomyFormConfig,
    useGetPolynomyBaseValues,
    useGetContratoDI,
    useOfCheckIfNewEdPDateNeeded
}